<div fxLayout="row" fxLayoutAlign="start center" class="divider">
  <div class="separator disableSelection text-ellipsis">
    {{ separatorText | translate }}
  </div>
</div>
